// ----------------------------------------------------------------------------
// Snippet: Recharge
// ----------------------------------------------------------------------------
import $ from 'jquery';

$('.js-rc__frequency-option').on('click', function(){
	if( !$(this).hasClass('is-active') ){
		$(this).siblings().removeClass('is-active');
		$(this).addClass('is-active');
		var frequencySelect = $(this).parents('.rc__delivery-container').siblings('.rc_label').children('.rc_select__frequency');
		var selectedFrequency = $(this).attr('data-value');
		frequencySelect.val(selectedFrequency);
	}
})